import React, { useCallback, useLayoutEffect, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import GlobalStyle from './styles/global';
import AppProvider from './hooks/index';
import Routes from './routes';
import Preloader from './components/Preloader'
import FadeIn from 'react-fade-in';
import 'bootstrap/dist/css/bootstrap.min.css';


const App: React.FC = () => {


  const [loading, setLoading] = useState(true)


  const handleLoad = useCallback(() => {
    setLoading(false)
  }, [])


  useLayoutEffect(()=>{
    window.addEventListener('load', handleLoad);
  },[handleLoad])


  return (
    <Router>
      <AppProvider>
        {loading ? <Preloader /> : (
          <FadeIn delay={1000} transitionDuration={1000}>
            <Routes />
          </FadeIn>
        )}
      </AppProvider>
      <GlobalStyle />
    </Router>
  )

}




export default App;


